module.exports = __webpack_public_path__ + "static/media/fin_dwn3.92837bbf.png";